import { FGTypography } from '@fg/design-system';

const DateSeparator = (props: { caption: string }) =>
    props.caption ? (
        <div className="day-divider">
            <div className="day-left-border" />
            <div className="day-caption">
                <FGTypography variant="body3-short" tag="label">
                    {props.caption}
                </FGTypography>
            </div>
            <div className="day-right-border" />
        </div>
    ) : (
        <div className="day-divider">
            <div className="day-left-border" />
        </div>
    );

export default DateSeparator;
